import {
  getDynLabel,
  getDynLabelId,
  getDynLabelMap,
  getDynLabelMapId,
} from '@/api/generated/digiVAPI';
import { createQuery } from '@/utils/tanstack-query/createQuery';
import { createInfiniteQuery } from '@/utils/tanstack-query/createQuery/createInifiniteQuery';

export const useLabel = createQuery({
  key: ['label'],
  queryFn: getDynLabel,
});

export const useLabelInfinite = createInfiniteQuery({
  key: ['label', 'infinite'],
  queryFn: getDynLabel,
});

export const useLabelId = createQuery({
  key: ['labelId'],
  queryFn: getDynLabelId,
});

export const useLabelMap = createQuery({
  key: ['labelMap'],
  queryFn: getDynLabelMap,
});

export const useLabelMapInfinite = createInfiniteQuery({
  key: ['labelMap', 'infinite'],
  queryFn: getDynLabelMap,
});

export const useLabelMapId = createQuery({
  key: ['labelMapId'],
  queryFn: getDynLabelMapId,
});
